import { useState, useCallback } from "react";
import { Menu, Box } from "@mui/material";

// Moved outside for performance
const menuCss = {
  display: 'flex',
  gap: 1,
  alignItems: 'center',
  position: 'relative',
};

const defaultSlotProps = {
  paper: {
    elevation: 0,
    sx: {
      overflow: 'visible',
      filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
      mt: 1.5,
      '& .MuiAvatar-root': {
        width: 32,
        height: 32,
        ml: -0.5,
        mr: 1,
      },
      '&::before': {
        content: '""',
        display: 'block',
        position: 'absolute',
        top: 0,
        width: 10,
        height: 10,
        bgcolor: '#ffd80c',
        transform: 'translateY(-50%) rotate(45deg)',
        zIndex: 0,
      },
    },
  },
};

function SubMenus({ name, icon, children, enableCustomStyle = true, position = "bottom", pointPos = "left" }) {
  const [anchorEl, setAnchorEl] = useState(null);
  const isOpen = Boolean(anchorEl);
  if (pointPos == 'right') {
    defaultSlotProps["paper"]["sx"]['&::before']['left'] = 'auto'
    defaultSlotProps["paper"]["sx"]['&::before'][pointPos] = 14
  } else {
    defaultSlotProps["paper"]["sx"]['&::before']['right'] = 'auto'
    defaultSlotProps["paper"]["sx"]['&::before'][pointPos] = 14
  }
  const handleClick = useCallback((event) => {
    // Toggle open/close on click
    setAnchorEl((prev) => (prev === event.currentTarget ? null : event.currentTarget));
  }, []);

  const handleClose = useCallback(() => {
    setAnchorEl(null);
  }, []);

  const handleMenuClick = (e) => {
    if (e.target.getAttribute('closable') === 'true') {
      setAnchorEl(null);
    }
  };

  return (
    <>
      <div
        aria-haspopup="true"
        onClick={handleClick}
        style={menuCss}
      >
        {name || icon}
      </div>

      <Menu
        sx={{ borderRadius: 18, mt: 1 }}
        anchorEl={anchorEl}
        open={isOpen}
        onClose={handleClose}
        onClick={handleMenuClick}
        transformOrigin={{ horizontal: pointPos, vertical: 'top' }}
        anchorOrigin={{ horizontal: 'left', vertical: position }}
        slotProps={enableCustomStyle ? defaultSlotProps : {}}
      >
        <Box
          className="custom-border"
          sx={{ transform: 'translateY(-8px)', pt: 1, background: '#fbfbfb' }}
        >
          {children}
        </Box>
      </Menu>
    </>
  );
}

export default SubMenus;
